module.exports = __webpack_public_path__ + "static/img/zpj_08.6549460.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zpj_08.png
// module id = KZbb
// module chunks = 4